/**
 * Import Dependency
 */
import UserModel from 'model/User'

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  user : null
}

const getters = {
  user: state => {
    return state.user;
  }
}
const actions = {

}
const mutations = {
  resetUser(state) {
    state.user = null
  },
  setUser(state, { authenticatedUser }) {
    let user = {
      name: '',
      email: ''
    }
    let token = null
    
    if (authenticatedUser) {
      user.name = authenticatedUser.user_metadata.full_name
      user.email = authenticatedUser.email
      token = authenticatedUser.app_metadata.analistKey || null
    }

    state.user = new UserModel({
      name: user.name, 
      email: user.email,
      faunaKey: token
    })
  },
}

/**
 * Export
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
